(function () {
  'use strict';

  var DESCRIPTION_SELECTOR = [
    '[data-product-description]',
    '[data-product-readmore]',
    '.pxu-tabs .tab-panel',
    '.collapsible-tab__text',
    '.collapsible-tab__image',
    '.collapsible-tab__image-link',
  ].join(', ');
  var PLATEX_ORIGIN = 'https://www.platex.com';
  var EN_PREFIX = '/en';

  function isEnglishPath(pathname) {
    return pathname === EN_PREFIX || pathname.indexOf(EN_PREFIX + '/') === 0;
  }

  function isLocalizableOrigin(origin) {
    return origin === window.location.origin || origin === PLATEX_ORIGIN;
  }

  function getEnglishPath(pathname) {
    if (isEnglishPath(pathname)) {
      return pathname;
    }

    if (pathname === '/') {
      return EN_PREFIX;
    }

    return EN_PREFIX + pathname;
  }

  function getLocalizedDescriptionHref(href) {
    var url;
    var englishPath;

    if (href.indexOf('#') === 0 || href.indexOf('?') === 0) {
      return href;
    }

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return href;
    }

    if (!isLocalizableOrigin(url.origin)) {
      return href;
    }

    englishPath = getEnglishPath(url.pathname);

    if (englishPath === url.pathname) {
      return href;
    }

    url.pathname = englishPath;
    return url.toString();
  }

  function localizeLink(link) {
    var href = link.getAttribute('href');
    var localizedHref = getLocalizedDescriptionHref(href);

    if (localizedHref !== href) {
      link.setAttribute('href', localizedHref);
    }
  }

  function localizeProductDescriptionLinks() {
    var descriptionScopes;
    var i;

    if (!isEnglishPath(window.location.pathname)) {
      return;
    }

    descriptionScopes = document.querySelectorAll(DESCRIPTION_SELECTOR);

    for (i = 0; i < descriptionScopes.length; i++) {
      var links = descriptionScopes[i].querySelectorAll('a[href]');
      var j;

      if (descriptionScopes[i].matches && descriptionScopes[i].matches('a[href]')) {
        localizeLink(descriptionScopes[i]);
      }

      for (j = 0; j < links.length; j++) {
        localizeLink(links[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localizeProductDescriptionLinks);
  } else {
    localizeProductDescriptionLinks();
  }
})();
